import { motion, AnimatePresence } from "framer-motion";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/components/site/ThemeProvider";

export const ThemeToggle = () => {
    const { theme, toggleTheme } = useTheme();
    const isDark = theme === "dark";

    return (
        <button
            type="button"
            onClick={toggleTheme}
            data-testid="theme-toggle"
            aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
            className="group relative inline-flex h-10 w-10 items-center justify-center overflow-hidden rounded-full border"
            style={{
                borderColor: "var(--pg-border)",
                background: "var(--pg-surface)",
                color: "var(--pg-fg)",
            }}
        >
            <AnimatePresence mode="wait" initial={false}>
                {isDark ? (
                    <motion.span
                        key="sun"
                        initial={{ rotate: -45, scale: 0.6, opacity: 0 }}
                        animate={{ rotate: 0, scale: 1, opacity: 1 }}
                        exit={{ rotate: 45, scale: 0.6, opacity: 0 }}
                        transition={{ duration: 0.28, ease: [0.2, 0.8, 0.2, 1] }}
                        className="inline-flex"
                    >
                        <Sun className="h-4 w-4" strokeWidth={1.6} />
                    </motion.span>
                ) : (
                    <motion.span
                        key="moon"
                        initial={{ rotate: 45, scale: 0.6, opacity: 0 }}
                        animate={{ rotate: 0, scale: 1, opacity: 1 }}
                        exit={{ rotate: -45, scale: 0.6, opacity: 0 }}
                        transition={{ duration: 0.28, ease: [0.2, 0.8, 0.2, 1] }}
                        className="inline-flex"
                    >
                        <Moon className="h-4 w-4" strokeWidth={1.6} />
                    </motion.span>
                )}
            </AnimatePresence>
        </button>
    );
};

export default ThemeToggle;
